
import PropTypes from 'prop-types'
import React from 'react'

import { withLegacyRouter } from '../../../decorators'
import http from '../../../lib/http'
import { makeCancelable } from '../../../lib/utils.js'
import FriendlyDate from '../../shared/Date/FriendlyDate.jsx'
import DownloadLink from '../../shared/DownloadLink/DownloadLink.jsx'
import MagicGrid from '../../shared/MagicGrid/index.jsx'
import { CircularProgress } from '../../shared/NarusMaterial'

@withLegacyRouter
export default class Documents extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      loading: true,
      documents: [],
      promise: null
    }
  }

  componentDidMount () {
    const { patientId, clientName } = this.props
    if (patientId && clientName) {
      this.fetchDocumentsInfo(patientId, clientName)
    }
  }

  componentDidUpdate (prevProps) {
    const { patientId, clientName } = this.props
    if (patientId !== prevProps.patientId && patientId && clientName) {
      this.fetchDocumentsInfo(patientId, clientName)
    }
  }

  componentWillUnmount () {
    this?.state?.promise?.cancel()
  }

  fetchDocumentsInfo (patientId, clientName) {
    if (this.state.promise) {
      this.state.promise.cancel()
    }

    const request = http.getRequest(
      `/patients/${patientId}/documents`,
      {},
      { clientName }
    )

    const promise = makeCancelable(request)

    promise.promise
      .then(response => {
        this.setState({
          documents: response,
          loading: false,
          promise: null
        })
      })
      .catch(err => {
        if (err.isCancelled) {
          return null
        }
        return console.warn(err)
      })
      .finally(() => {
        this.setState({
          loading: false
        })
      })

    this.setState({ promise })
  }

  render () {
    const { id, clientName } = this.props.params
    const { documents, loading } = this.state

    const renderFileLink = r => (
      <DownloadLink
        patientId={id}
        meta={r.meta}
        type={r.type}
        clientName={clientName}
      />
    )

    const renderEffectiveDate = r => <FriendlyDate date={r.datetime} />

    const headers = [
      {
        displayFn: renderFileLink,
        title: 'Document',
        sortFn: (a, b) => {
          if (a.meta.filename.toLowerCase() > b.meta.filename.toLowerCase()) {
            return 1
          }
          return a.meta.filename.toLowerCase() === b.meta.filename.toLowerCase()
            ? 0
            : -1
        }
      },
      {
        displayFn: renderEffectiveDate,
        sortFn: (a, b) => {
          const aVal = a.datetime
          const bVal = b.datetime
          if (aVal > bVal) {
            return 1
          }
          if (aVal === bVal) {
            return 0
          }
          return -1
        },
        title: 'Date'
      }
    ]

    if (loading) {
      return (
        <div>
          <CircularProgress />
        </div>
      )
    }

    return (
      <MagicGrid
        disableGrid
        itemName='Documents'
        canDelete={false}
        sortOn={1}
        headers={headers}
        rows={documents || []}
      />
    )
  }
}

Documents.propTypes = {
  patientId: PropTypes.string.isRequired
}
